<template>
    <label class="order-bump" :data-selected="selected" :style="style" :class="[advanced.cssClasses, responsiveClasses]">
        <div class="ob-header" :style="labelStyle">
	        <input type="checkbox" name="product-id"
	               :value="productId" :data-selected="selected">
	        <span class="ob-headline" v-html="content.content ? content.content.headline : 'Yes, I will take it'"></span>
        </div>
        <div class="ob-content" v-html="content.content ? content.content.content : defText"></div>
    </label>
</template>

<script>

import {borderProps, boxShadow, fontProps, getPadding} from "@/modules/page-editor/src/utils/props";

export default {
    name: 'EmailOrderBump',
    props: ['details'],
    components: {
    },
    data: function(){
        return {
            defText: '<p><span style="font-weight:bold"><span style="color:#FB595B">ONE TIME OFFER!</span></span> Aliqua id fugiat nostrud irure ex duis ea quis id quis ad et. Sunt qui esse pariatur duis deserunt mollit dolore cillum minim tempor enim. Elit aute irure tempor cupidatat incididunt sint deserunt ut voluptate aute id deserunt nisi.</p>'
        }
    },
    computed: {
        content() {
            return this.details;
        },
        basic() {
            return this.content.attributes.basic
        },
        advanced() {
            return this.content.attributes.advanced
        },
        responsive() {
            return this.details.responsive
        },
		    selected(){
			    return this.basic.selected && this.basic.selected.booleanValue;
		    },
	    productId() {
        	if (this.basic.product) return this.basic.product;
        	return 'ob-1';
	    },
	    responsiveClasses() {
            let c = '';
            if (!this.responsive) return '';
            if (!this.responsive.desktop) c = 'no-desktop';
            if (!this.responsive.mobile) c += ' no-mobile';
            if (!this.responsive.tablets) c += ' no-tablet';
            return c;
        },
	    labelStyle() {
		    return {
		    	...fontProps(this.basic.labelFont),
		    };
	    },
	    style() {
		    return {
		    	...borderProps(this.basic.border),
			    margin: getPadding(this.basic.margin),
			    padding: getPadding(this.advanced.padding),
			    backgroundColor: this.basic.backgroundColor,
			    boxShadow: boxShadow(this.basic.shadows),
		    };
	    }
    },
    methods: {

    },
    created() {

    }
}
</script>
